import { createContext } from 'react';
import { defaultValue } from './';

const UserContext = createContext(defaultValue.user);

export default UserContext;
